import React from "react";
import {Route, Switch} from "react-router";

import App from "./App";
import {MenuLayout} from "./layouts/MenuLayout";
import {RouteWithLayout} from "./layouts/RouteWithLayout";
import {FullPage} from "./pages/additional-data/FullPage";
import ProposedBOMs from "./pages/additional-data/ProposedBOM";
import {ColumnsPreferences} from "./pages/settings/ColumnsPreferences";

export function IHRouter() {
	return (
		<div>
			<Switch>
				<Route path="/proposed*" render={props => <ProposedBOMs {...props} />} />

				<Route path="/data*" render={props => <FullPage {...props} />} />

				<RouteWithLayout
					layout={MenuLayout}
					path="/settings/columns-preferences"
					component={ColumnsPreferences}
				/>
				<RouteWithLayout layout={MenuLayout} path="/settings" />

				<Route path="/*" render={props => <App {...props} />} />
			</Switch>
		</div>
	);
}
